<div class="webmate" [id]="viewId">
  <wm-modaltoolcontainer></wm-modaltoolcontainer>
  <p-toast [style]="{marginTop: '50px'}"></p-toast>
  <p-toast key="disconnect" [style]="{marginTop: '50px'}">
    <ng-template pTemplate="message">

      <span class="p-toast-message-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </span>

      <div class="p-toast-message-text">
        <div class="p-toast-summary">Connection restored</div>
        <div class="p-toast-detail">
          Refresh the page if the view appears to be out of sync.<br>
          <br>
            <a style="text-decoration: underline; cursor: pointer" (click)="reload()">Click here to refresh</a>
          </div>
        </div>
      </ng-template>
    </p-toast>
    <p-dialog [(visible)]="displayConsentModal" [showHeader]="false" [modal]="true" [closeOnEscape]="false" [style]="{width: '800px'}" [draggable]="false" [resizable]="false">
      <div class="modal-header">
        @if (displayConsentModal) {
          <img class="modal-header-picture" src="/assets/img/tracking_consent_illustration.svg"/>
        }
      </div>
      <div class="modal-content">

        @if (consentMessage.trim().length > 0) {
          <div [innerHTML]="consentMessage"></div>
        }
        @else {
            <div class="headline">Help us improve webmate</div>
            <div class ="entry">
              With your consent, we collect limited usage data about your use of webmate for UX research and product improvement.
              This may include:
            </div>
            <div class="signup-modal-bullet-point-list">
              <div class="entry">
                <div class="bullet">
                  <fa-icon icon="circle"></fa-icon>
                </div>
                <div class="text">which areas and functions of webmate are used.</div>
              </div>
              <div class="entry">
                <div class="bullet">
                  <fa-icon icon="circle"></fa-icon>
                </div>
                <div class="text">
                  technical browser and device information, such as browser type, screen size, and viewport
                </div>
              </div>
              <div class="entry">
                <div class="bullet">
                  <fa-icon icon="circle"></fa-icon>
                </div>
                <div class="text">
                  filter and view settings used frequently.
                </div>
              </div>
            </div>
            <div class ="entry">
              We use this data only to understand user journeys, identify usability issues, and improve workflows, navigation, and default settings in webmate.
              This data is not used to evaluate individual employee performance or behavior.
              Your participation is voluntary. You can use webmate even if you do not consent. You can withdraw your consent at any time in your user profile with effect for the future.
              Your decision (consent or refusal) is not visible to administrators of your organization.
              In addition, the data protection provisions agreed in the contract apply.
            </div>
        }
      </div>
      <div class="modal-footer">
        <button pButton class="p-button button" label="Yes, I agree" (click)="saveConsentStatus(true)"></button>
        <button pButton class="p-button-outlined button" label="No, I decline" (click)="saveConsentStatus(false)"></button>
      </div>
    </p-dialog>
    <div class="wm-l-topbar">
      <div class="wm-l-topbar-logo">
        <img [routerLink]="['/projects/overview']" src="/assets/img/webmate_logo_icon_no_bg.svg">
      </div>
      <div class="wm-l-topbar-content">
        <div class="wm-l-topbar-left">
          @if (isAuthenticated) {
            <wm-projectchooser class="wm-l-topbar-projectchooser">Recent Projects</wm-projectchooser>
          }
          @if (isAuthenticated && showAdmin) {
            <div class="wm-l-topbar-link" [routerLink]="['/administration/users']" data-testing-id="administrator-label">Administration</div>
          }
          @if (isAuthenticated && isWebmateAdmin) {
            <wm-wmadmindropdown class="wm-l-topbar-link">Webmate Administration</wm-wmadmindropdown>
          }
          @if (isAuthenticated && marketplaceAvailable) {
            <div class="marketplace-button">
              <button pButton type="button" class="p-button-outlined wm-topbar-action-button" aria-label="Marketplace" pTooltip="Marketplace" tooltipPosition="bottom" (click)="openMarketplace()" data-testing-id="marketplace-btn">
                <fa-icon class="marketplace-button-icon" icon="store" [fixedWidth]="true"></fa-icon>
                <span class="wm-topbar-action-label">Marketplace</span>
              </button>
            </div>
          }
        </div>

        <div class="wm-l-topbar-right">
          @if (demoInstance) {
            <a class="wm-l-contact" href="https://testfabrik.com/pricing/" target="_blank" data-testing-id="topbar-helt-label">Configure your plan</a>
          }
          @if (shouldShowRunTestDialog) {
            <div class="p-d-flex run-test-button">
              <button pButton class="p-button-outlined quick-start-gradient wm-topbar-action-button" aria-label="Quick Start" pTooltip="Quick Start" tooltipPosition="bottom" (click)="openRunTestDialog()" data-testing-id="run-test-btn">
                <fa-icon icon="bolt"></fa-icon>
                <span class="wm-topbar-action-label">Quick Start</span>
              </button>
            </div>
          }
          @if (shouldShowOpenWorkbench) {
            <div class="p-d-flex open-workbench-button">
              <button pButton class="p-button-outlined wm-topbar-action-button" aria-label="Open Workbench" pTooltip="Open Workbench" tooltipPosition="bottom" (click)="openWorkbench()" data-testing-id="open-workbench-btn">
                <fa-icon [icon]="faTv" [fixedWidth]="true"></fa-icon>
                <span class="wm-topbar-action-label">Open Workbench</span>
              </button>
            </div>
          }
          @if (internalSupportFeature.isActive) {
            <wm-internal-support [feature]="internalSupportFeature" class="wm-l-topbar-container"></wm-internal-support>
          }
          @if (isAuthenticated) {
            <wm-helpdropdown class="wm-l-topbar-container" [demoInstance]="demoInstance"></wm-helpdropdown>
          }
          @if (isAuthenticated) {
            <wm-usernotifications class="wm-l-topbar-container"></wm-usernotifications>
          }
          @if (isAuthenticated) {
            <wm-userdropdown class="wm-l-topbar-avatar">
              <wm-avatar [size]="24" [userId]="userId"></wm-avatar>
            </wm-userdropdown>
          }
          @if (!isAuthenticated) {
            <a class="wm-l-topbar-right-sign-in" [routerLink]="['/login']" data-testing-id="user-login-link">SIGN IN</a>
          }
        </div>
      </div>
    </div>
    @if (adminWarning) {
      <div class="wm-l-warnbar">{{adminWarning}}</div>
    }
    <div class="wm-l-maincontent">
      <router-outlet></router-outlet>
    </div>
    <wm-sidebar-right class="wm-l-sidebar-right"></wm-sidebar-right>
  </div>
